var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-vimeo-player",class:{
    'video-vimeo-player--auto-height': _vm.autoHeight
  }},[_c('app-full-sticky-bg',{attrs:{"isPlay":""},on:{"startPlay":_vm.onStartPlay}}),(_vm.played)?_c('HMTVimeoPlayer',{attrs:{"url":_vm.url}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }